
import { Component, Vue, Prop } from 'vue-property-decorator';
import InfoTooltip from '@/app/components/common/InfoTooltip.vue';

@Component({
  components: {
    InfoTooltip,
  },
})
export default class NotificationSettingsTable extends Vue {
  @Prop({ default: false }) rateAlert!: string | boolean;

  @Prop({ default: false }) loading!: boolean;

  @Prop({ default: false }) hideTargets!: string | boolean;

  get isStackedView() {
    return this.$mediaQuery.is('mdDown');
  }
}
